import { QueryParams } from '../commonMixed';

export class GetStatesRequest extends QueryParams {}

export class GetInvoiceTermsRequest extends QueryParams {}
